import { Stack } from '@mui/material'
import React from 'react'
import { Control, UseFormWatch } from 'react-hook-form'

import { observer } from 'mobx-react'
import FormField from '../../../../../components/Form/FormField'
import TypedAccordion from '../../../../SingleRequestPage/components/SingleRequestDrawer/elements/TypedAccordion'
import { Mode } from '../NewServiceResultsDrawer'
import { ActiveOrder, ServiceCenterForm } from '../types/NewDrawers.types'
import CheckedForm from './CheckedForm'
import RequestList from './RequestList'

interface EquipmentDataSectionProps {
  control: Control<ServiceCenterForm>
  watch: UseFormWatch<ServiceCenterForm>
  mode: Mode
  serialResponse: any
  selectedServiceRequest: ActiveOrder | null
  openedAccordionIndex: number
  setOpenedAccordionIndex: (index: number) => void
  getOnCheck: (request: ActiveOrder) => void
}

const EquipmentDataSection: React.FC<EquipmentDataSectionProps> = ({
  control,
  watch,
  mode,
  serialResponse,
  selectedServiceRequest,
  openedAccordionIndex,
  setOpenedAccordionIndex,
  getOnCheck,
}) => {
  return (
    <TypedAccordion
      contentPadding={'8px 0 !important'}
      summary={'Данные оборудования'}
      customOpen
    >
      <Stack paddingX={'16px'} spacing={'14px'} marginTop={'16px!important'}>
        <FormField
          control={control}
          name='serialNumber'
          fullWidth
          label='S/N оборудования'
          onlyNumbers
          error={watch('serialNumber').length !== 23}
          inputProps={{
            maxLength: 23,
          }}
        />
        {mode === 'checked' && (
          <CheckedForm
            control={control}
            malfunctionError={!watch('serviceCenterMalfunctionId')}
            malfunctionText={watch('serviceCenterMalfunctionId')}
            possibleMalfunctions={
              serialResponse?.receiver?.possibleMalfunctions
            }
          />
        )}
      </Stack>

      <RequestList
        mode={mode}
        serialResponse={serialResponse}
        watch={watch}
        selectedServiceRequest={selectedServiceRequest}
        openedAccordionIndex={openedAccordionIndex}
        setOpenedAccordionIndex={setOpenedAccordionIndex}
        getOnCheck={getOnCheck}
      />
    </TypedAccordion>
  )
}

export default observer(EquipmentDataSection)
